import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectUserType } from '../../../../../layout/store/slice'
import { USER_TYPE } from '../../../../../utils/authorization'
import CashBreakdownTrend from '../../common/cashFlow/Trend'
import {
  getNoDataComponent,
  getValueAndTitleCheckbox,
  handleIconDownload,
} from '../../helper'
import { changeChecked, selectChecked } from '../../store/slice'
import { selectDataViewByTrend, selectIndicatorById } from './store/slice'

export const Trend = ({ id, isDynamicReport, check, isDownloadComponent }) => {
  const dispatch = useDispatch()

  const userType = useSelector(selectUserType)
  const dataByTrend = useSelector(selectDataViewByTrend)
  const indicatorById = useSelector(selectIndicatorById)
  const checkedStore = useSelector(selectChecked(id))

  const checked = checkedStore || check

  const setChecked = (checked) => dispatch(changeChecked({ id, checked }))

  const checkboxs = [
    {
      ...getValueAndTitleCheckbox(indicatorById, 'CF19'),
      color: '#74B49A',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'CF30'),
      color: '#FFCD60',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'CF37'),
      color: '#006AA6',
      isBarChart: true,
    },
    {
      ...getValueAndTitleCheckbox(indicatorById, 'CF38'),
      color: '#F49966',
      isLineChart: true,
    },
  ]

  const isNoData = !dataByTrend?.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (!dataByTrend?.length) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <CashBreakdownTrend
      id={id}
      data={dataByTrend}
      indicatorById={indicatorById}
      isCheckbox={userType?.userTypeId === USER_TYPE.PREMIUM}
      checkboxs={checkboxs}
      checked={checked}
      setChecked={setChecked}
      isDynamicReport={isDynamicReport || isDownloadComponent}
    />
  )
}
